import { EUserRole } from "@/3514/types"
import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

function loadingValue({ isBlurred, intensity }: { isBlurred: boolean; intensity: 3 | 5 }): string {
    return buildCssClassName(
        { "blur-[3px] opacity:[0.8] scale:[0.95]": isBlurred && intensity === 3 },
        { "blur-[10px] opacity-100 scale-[1]": isBlurred && intensity === 5 },
        getTransitionTwClasses("all,[width]", 200)
    )
}

export default {
    [EUserRole.Coach]: {
        userInfoContainer: (): string => "w-full flex flex-col max-[767px]:mt-[15px]",
        metaWrapper: (): string =>
            "pt-[5px] md:pt-[10px] pb-[10px] md:pb-[25px] px-[20px] md:px-[40px] flex gap-x-[10px] items-center",
        metaTextWrapper: (): string => "block md:flex md:flex-row w-auto overflow-x-hidden gap-x-[10px] items-baseline",
        loadingValue,
        metaBigText: (): string => "line-clamp-1 truncate max-w-[100%]",
        metaSmallText: (): string => "md:ml-[5px] line-clamp-1 max-w-[100%]"
    },
    [EUserRole.Assistant]: {
        userInfoContainer: (): string => "pt-[10px] pb-[25px] px-[0px] md:px-[40px] flex gap-x-[10px] items-center",
        loadingValue
    }
}
